export default __webpack_public_path__ + "images/80ef4ed90d05f83cacba887bee9ff917.webp";